'use strict';

(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.dlaCloaking = {
    attach: function attach(context, settings) {
      // $(document, context).once('cloaking').ready(function() {
      $(once('cloaking', 'html', context)).ready(function() {
        // $('.la-cloak', context).once('cloaking').each(function () {
        $(once('cloaking', '.la-cloak', context)).each(function () {
          $(this).removeClass('la-cloak');
        });
      });
    }
  };

})(jQuery, Drupal, once);
